import { BaseRouteService } from "core/services";

class FacilityOrderStatusRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-statuses");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityOrderId}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}	
}

export default FacilityOrderStatusRouteService;